import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth/authService';
import { getEffectiveOrgModuleSlugs, getPostLoginPath } from '../utils/entitlements';

/**
 * An address no route matches: a signed-in person goes to their home (the page sign-in would
 * open), not to the sign-in page as if the session had ended; anyone else signs in.
 */
const UnknownRoute = () => (authService.isAuthenticated()
  ? <Navigate to={getPostLoginPath(getEffectiveOrgModuleSlugs())} replace />
  : <Navigate to="/" replace />);

export default UnknownRoute;
